// extracted by mini-css-extract-plugin
export default {"alert":"Banner_alert__KwkQM","icon":"Banner_icon__8hCQS","title":"Banner_title__nMhSv"};